/* Polsk katalog for locale-inbox-vouchers-no.js (del 2 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'inbox.inboxWithCount': 'Skrzynka odbiorcza ({count})',
  'inbox.wordDocuments': 'dokumenty',
  'inbox.wordVouchers': 'dowody księgowe',
  'inbox.emptyDocsTitle': 'Brak dokumentów',
  'inbox.emptyTrashTitle': 'Kosz jest pusty',
  'inbox.emptyDocsText': 'Prześlij tutaj umowy, kontrakty i dokumenty.',
  'inbox.searchDocsFull': 'Szukaj w dokumentach - nazwa pliku, typ...',
  'inbox.vehicleCostReminderDefault': 'Tylko jeśli firma jest właścicielem pojazdu lub go leasinguje.',
});
